var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartWatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,165.1l-6,21.82H85.92l-6-21.82m0-91.53,6-21.83H122l6,21.83m1.24,91.53H78.66a13.88,13.88,0,0,1-13.78-13.9V82.9a9.32,9.32,0,0,1,9.25-9.33h59.66A9.32,9.32,0,0,1,143,82.9v68.3A13.89,13.89,0,0,1,129.25,165.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.81,62.24l.12,0a17.3,17.3,0,0,1,19.41,14.94l0,.11m-19-26.85.13,0m0,0a27.2,27.2,0,0,1,30.54,23.5V74M136.4,39a36.55,36.55,0,0,1,41,31.56v.11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartWatch);
export default __webpack_public_path__ + "static/media/SMART_WATCH.2afa0f8fa7871c9e9c645afcd085fcd1.svg";
export { ForwardRef as ReactComponent };